<div class="form-group">
  <label class="ml-0" *ngIf="label">{{label}}<span class="red" *ngIf="requiredMark">*</span></label>
  <select [disabled]="currentControl.disabled || disabled" class="custom-select {{inputClasses}}" *ngIf="options" [(ngModel)]="model" (change)="setValue(model)" [ngClass]="{'is-invalid': hasValidationError()}">
    <option *ngIf="placeholder" [disabled]="disableDefault" [value]="null">{{ placeholder }}</option>
    <option *ngFor="let option of options" [ngValue]="option">{{textOption ? option[textOption] : option}}</option>
  </select>

  <div class="invalid-feedback" *ngIf="hasValidationError()">
    {{invalidMsg}}
  </div>
</div>